<managed-list
    [legend]="'Tags'"
    [fields]="fields"
    [type]="'tags'"
    [fbFields]="properties"
    submitURL="tags"
></managed-list>